var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"quickgraphs_app"}},[_c('GraphToolbar'),_c('GraphMain'),_c('GraphContextMenu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }